import { AnalyticsService } from "./AnalyticsService";

// One instance per scope, imported by every consumer of that scope, because the names must not
// drift between them. Module singletons rather than AnalyticsContext: the chat's sagas emit nine of
// these events and a saga has no context to read, all three scope names are constants so there is
// nothing for the tree to supply, and a component rendered outside a provider would silently fall
// back to the root service and emit an unprefixed name.
const fieldAgentAnalytics = new AnalyticsService("Field Agent");

export const fieldAgentChatAnalytics = new AnalyticsService("Field Agent Chat");

export const fieldAgentSettingsAnalytics = new AnalyticsService("Field Agent Settings");

export default fieldAgentAnalytics;
